import { ApiResponse, GlobalStore } from "@roc/feature-app-core";
import { flow, makeObservable, observable } from "mobx";
import { DocumentStore } from "@roc/feature-documents";
import { LoanStore } from "@roc/feature-loans";
import { FirstAppraisalValueConfirmationService } from "../../../services/documentForms/firstAppraisalValueConfirmation/firstAppraisalValueConfirmationService";

export const CONFIRMED_VALUATION_STATUS = 'CONFIRMED';
export const REJECTED_VALUATION_STATUS = 'REJECTED';
export const REFUNDED_VALUATION_STATUS = 'REFUNDED';

export class FirstAppraisalValueConfirmationStore {
  private documentStore: DocumentStore;
  private globalStore: GlobalStore;
  loanStore: LoanStore;
  firstAppraisalValueConfirmationService: FirstAppraisalValueConfirmationService;

  appraisalValue1: number;
  confirmValuationStatus: string;

  constructor(
    loanStore: LoanStore,
    documentStore: DocumentStore,
    globalStore: GlobalStore
  ) {
    this.documentStore = documentStore;
    this.globalStore = globalStore;
    this.loanStore = loanStore;
    this.firstAppraisalValueConfirmationService = new FirstAppraisalValueConfirmationService();
    this.setDefaults();
    makeObservable(this, {
      initialize: flow,
      appraisalValue1: observable,
      confirmValuationStatus: observable,
      getFirstAppraisalData: flow,
      saveConfirmValuationStatus: flow,
      processAppraisalRefund: flow,
    });
  }

  setDefaults() {
    this.appraisalValue1 = null;
    this.confirmValuationStatus = null;
  }

  reset() {
    this.setDefaults();
  }

  *initialize() {
    this.reset();
    yield this.getFirstAppraisalData();
  }

  *getFirstAppraisalData() {
    try {
      const response: ApiResponse = yield this.firstAppraisalValueConfirmationService.getPropertyAppraisalConfirmValuationStatus(this.loanStore?.loanDetails?.loanId, this.documentStore?.currentDocument?.collateralId);
      if (response?.data?.data) {
        this.appraisalValue1 = response?.data?.data?.appraisalValue1;
        this.confirmValuationStatus = response?.data?.data?.confirmValuationStatus;
      }
    }
    catch (error) {
      console.log(error);
      if (error?.error?.response?.data?.error?.message) {
        this.globalStore.notificationStore.showErrorNotification({
          message: error?.error?.response?.data?.error?.message,
        });
      }
      else {
        this.globalStore.notificationStore.showErrorNotification({
          message: 'An error occurred while getting first appraisal data.',
        });
      }
    }
  }

  *saveConfirmValuationStatus(status: string, onClose?) {
    try {
      const response: ApiResponse = yield this.firstAppraisalValueConfirmationService.saveConfirmValuationStatus(this.documentStore?.currentDocument?.taskId, status);
      this.globalStore.notificationStore.showSuccessNotification({
        message: 'First appraisal valuation status updated.',
      });
      if (onClose) {
        onClose();
      }
    }
    catch (error) {
      console.log(error);
      if (error?.error?.response?.data?.error?.message) {
        this.globalStore.notificationStore.showErrorNotification({
          message: error?.error?.response?.data?.error?.message,
        });
      }
      else {
        this.globalStore.notificationStore.showErrorNotification({
          message: 'An error occurred while saving first appraisal valuation status.',
        });
      }
    }
  }

  *processAppraisalRefund(onClose?) {
    try {
      const response: ApiResponse = yield this.firstAppraisalValueConfirmationService.processAppraisalRefund(this.loanStore?.loanDetails?.loanId, this.documentStore?.currentDocument?.collateralId, 'secondAppraisal');
      this.globalStore.notificationStore.showSuccessNotification({
        message: 'Refund process started.',
      });
      if (onClose) {
        onClose();
      }
    }
    catch (error) {
      console.log(error);
      if (error?.error?.response?.data?.error?.message) {
        this.globalStore.notificationStore.showErrorNotification({
          message: error?.error?.response?.data?.error?.message,
        });
      }
      else {
        this.globalStore.notificationStore.showErrorNotification({
          message: 'An error occurred while starting refund process.',
        });
      }
    }
  }

}